import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { SkeletonLoader } from '@vio/atlas/SkeletonLoader';
import { Text } from '@vio/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import UnifiedDateTime from '../../../utils/UnifiedDateTime';
import { getOfferEligibility } from '../../modules/selector';
type TextAlign = 'left' | 'center';
const _exp = /*#__PURE__*/() => ({
  alignment
}) => alignment;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wqthmrj",
  propsAsIs: false,
  vars: {
    "wqthmrj-0": [_exp()]
  }
});
interface Props {
  isLoading: boolean;
  alignment?: TextAlign;
}
export const FreezeDetailsHeader: React.FC<Props> = ({
  isLoading,
  alignment = 'center'
}) => {
  const {
    response: offerCheckResponse
  } = useSelector(getOfferEligibility);
  if (isLoading) {
    return <Flex.Column alignItems={alignment === 'left' ? 'flex-start' : 'center'}>
        <SkeletonLoader width={260} height={32}></SkeletonLoader>
        <SkeletonLoader width={328} height={24} marginTop={4}></SkeletonLoader>
        <SkeletonLoader width={232} height={24} marginTop={4}></SkeletonLoader>
      </Flex.Column>;
  }
  return <Wrapper alignment={alignment}>
      <Flex.Column gap="s100">
        <Text variant="titleXL" align="center">
          <FormattedMessageWrapper id="dealFreeze.freezeOverlayTitle" defaultMessage="Freeze this deal for free" />
        </Text>
        {offerCheckResponse?.expiresAt && <Text variant="bodyM" align="center">
            <FormattedMessageWrapper id="dealFreeze.freezeOverlayExplanation" defaultMessage="Secure the price and availability of this stay until {date} – no card details required." values={{
          date: <UnifiedDateTime value={offerCheckResponse?.expiresAt} format={'date-longform'} />
        }} />
          </Text>}
      </Flex.Column>
    </Wrapper>;
};

require("./FreezeDetailsHeader.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FreezeDetailsHeader.tsx");